export const cancelOrderModalStyles = {
  dialogTitleBoxStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    px: "24px",
    py: "16px",
    borderBottom: "1px solid rgba(234, 234, 234, 1)",
  },
  dialogTitleStyle: {
    fontWeight: 500,
    color: "rgba(47, 43, 61, 0.9)",
    fontSize: "18px",
    lineHeight: "28px",
    p: 0,
    m: 0,
  },
  dialogContent: { p: "24px", pb: "32px", pt: "32px" },
  dialogContentTextStyle: {
    fontSize: "18px",
    fontWeight: 500,
    color: "rgba(47, 43, 61, 0.9)",
    lineHeight: "28px",
  },
  dialogActions: {
    px: "24px",
    py: "12px",
    justifyContent: "space-between",
    flexDirection: { xs: "column", sm: "row" },
    gap: "8px",
  },
  backButtonStyle: {
    backgroundColor: "rgba(128, 131, 144, 1)",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "500",
    color: "white",
    textTransform: "none",
    width: { xs: "100%", sm: "auto" },
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "rgba(128, 131, 144, 0.9)",
    },
  },
  cancelButtonStyle: {
    ml: "0px !important",
    textTransform: "none",
    color: "rgba(255, 255, 255, 1)",
    width: { xs: "100%", sm: "auto" },
    fontWeight: 500,
    fontSize: "15px",
    borderRadius: "8px",
    px: "16px",
    py: "6px",
    backgroundColor: "rgba(183, 72, 74, 1)",
    borderColor: "rgba(183, 72, 74, 1)",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "rgba(183, 72, 74, 0.9)",
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(183, 72, 74, 0.4)",
      color: "rgba(255, 255, 255, 0.7)",
    },
  },
  loader: {
    color: "rgba(255, 255, 255, 1)",
    ml: "8px",
  },
};
